// extracted by mini-css-extract-plugin
export default {"PollingIndicator":"PollingIndicator_PollingIndicator__itxpk"};